module.exports = __webpack_public_path__ + "static/media/PHEV_JEA.27e2dbec.svg";